import Table from 'components/atomic/molecules/table'
import SharedAnchor from 'components/pages/@shared/mdx/anchor'
import AnchorHeading from 'components/pages/@shared/mdx/anchor-heading'
import CardGridWidget from 'components/pages/@shared/mdx/card-grid-widget'
import CardWidget from 'components/pages/@shared/mdx/card-widget'
import SharedCode from 'components/pages/@shared/mdx/code'
import CodeAnchor from 'components/pages/@shared/mdx/code-anchor'
import SharedImg from 'components/pages/@shared/mdx/img'
import SharedInlineCode from 'components/pages/@shared/mdx/inline-code'
import { TabItem, Tabs } from 'components/pages/@shared/mdx/tabs'
import TwitterWidget from 'components/pages/@shared/mdx/twitter-widget'
import SharedWrapper from 'components/pages/@shared/mdx/wrapper'
import YoutubeWidget from 'components/pages/@shared/mdx/youtube-widget'

const sharedComponents = {
  wrapper: SharedWrapper,
  h2: props => <AnchorHeading {...props} tag="h2" />,
  h3: props => <AnchorHeading {...props} tag="h3" />,
  a: props => SharedAnchor(props),
  img: props => SharedImg(props),
  pre: SharedCode,
  code: SharedInlineCode,
  table: props => (
    <Table.Root data-widget="table">
      <Table.Table {...props} />
    </Table.Root>
  ),
  thead: Table.Head,
  tbody: props => <Table.Body {...props} borderBottom />,
  tr: Table.Row,
  th: Table.CellHeader,
  td: Table.Cell,
  YoutubeWidget,
  TwitterWidget,
  Tabs,
  TabItem,
  CardWidget,
  CardGridWidget,
  CodeAnchor,
}

export default sharedComponents
